<template>
  <div>
    <div class="col-xs-12 col-sm-12 col-md-9 col-xl-6 col-xs-offset-0 col-sm-offset-0 col-md-offset-3 col-lg-offset-3 toppad">
      <div class="panel panel-info">
        <div class="panel-body">
          <div class="row">
            <div class="col-md-9 col-lg-9">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <td>Current Password</td>
                    <td>
                      <div class="form-group">
                        <div class="input-group input-group-md">
                          <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fa fa-lock"></i></span>
                          </div>
                          <input name="password" type="password" class="form-control input-lg" v-model.trim="password" v-validate="'required'" :class="{'is-invalid': errors.has('password') }" placeholder="Password">
                        </div>
                        <b-form-text class="is-invalid help" v-show="errors.has('password')" v-html="errors.first('password')">
                        </b-form-text>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>New Password</td>
                    <td>
                      <div class="form-group">
                        <div class="input-group input-group-md">
                          <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fa fa-lock"></i></span>
                          </div>
                          <input name="newPassword" :type="passwordInputType" class="form-control input-lg" v-model.trim="newPassword" v-validate="'required|password'" :class="{'is-invalid': errors.has('newPassword') }" placeholder="New Password">
                          <div class="input-group-append">
                            <span class="input-group-text"
                              @mousedown="showPassword"
                              @touchstart="showPassword"
                              @mouseleave="hidePassword"
                              @mouseup="hidePassword"
                              @touchend="hidePassword"
                              @touchcancel="hidePassword"
                            ><i class="far" :class="viewPasswordIcon"></i></span>
                          </div>
                        </div>
                        <b-form-text class="is-invalid help" v-show="errors.has('newPassword')" v-html="errors.first('newPassword')">
                        </b-form-text>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td></td>
                    <td>
                      <b-button class="rule-submit" type="submit" variant="success" @click.prevent="updatePassword"><i class="fas fa-check"></i><span class="pl-2">Update Password</span></b-button>
                    </td>
                  </tr>

                </tbody>
              </table>

            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import { CHANGE_PASSWORD_MUTATION } from '@/constants/graphql'
import { Validator } from 'vee-validate'

Validator.extend('password', {
  getMessage: () => {
    return 'Passwords should be at least 8 characters.'
  },
  validate: (value) => {
    return value.length >= 8
  }
})

export default {
  name: 'UserProfile',
  data () {
    return {
      password: '',
      newPassword: '',
      showPasswordInterval: false,
      passwordInputType: 'password',
      loading: false
    }
  },
  computed: {
    viewPasswordIcon () {
      return (this.passwordInputType === 'password') ? 'fa-eye-slash' : 'fa-eye'
    }
  },
  methods: {
    showPassword () {
      if (!this.showPasswordInterval) {
        this.showPasswordInterval = setInterval(() => {
          this.passwordInputType = 'text'
        }, 30)
      }
    },
    hidePassword () {
      clearInterval(this.showPasswordInterval)
      this.showPasswordInterval = false
      this.passwordInputType = 'password'
    },
    updatePassword () {
      this.$validator.validateAll().then((result) => {
        if (result) {

          this.$apollo.mutate({
            mutation: CHANGE_PASSWORD_MUTATION,
            variables: { password: this.password, newPassword: this.newPassword  }
          }).then(() => {
            this.$swal.fire({ icon: 'success', title: 'Success! Password Changed' })
            this.$router.push({ name: 'Account' })
          }).catch(() => {
            // handled by global onError handler but still need to catch in the promise
          })

        }
      })
    }
  },
  components: {
  }
}
</script>

<style scoped>
</style>
